function initSocialGallery() {
  const sliders = document.querySelectorAll(".custom-social-gallery-slider");

  if (!sliders.length) {
    return;
  }

  sliders.forEach((slider) => {
    const swiper = new Swiper(slider, {
      slidesPerView: 2.5,
      spaceBetween: 15,
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 4.5,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 5.5,
          spaceBetween: 20,
        },
      },
    });
  });
}

function initCustomMarquee() {
  const section = document.querySelectorAll(".custom-marquee");

  if (!section.length) {
    return;
  }

  section.forEach((section) => {
    const marqueeContainer = section.querySelector(".custom-marquee-wrapper");

    let isDragging = false;
    let startPos = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;

    if (window.innerWidth < 767) {
      // Add touch event listeners
      console.log("START");
      marqueeContainer.addEventListener("touchstart", startTouch);
      marqueeContainer.addEventListener("touchmove", moveTouch);
      marqueeContainer.addEventListener("touchend", endTouch);
    }

    // Function to start touch
    function startTouch(e) {
      isDragging = true;
      startPos = getPositionX(e); // Get the initial touch position
      marqueeContainer.style.transition = "none"; // Disable smooth transition during drag
    }

    // Function to move touch
    function moveTouch(e) {
      if (!isDragging) return;
      const currentPosition = getPositionX(e); // Get current touch position
      currentTranslate = prevTranslate + currentPosition - startPos;
      setMarqueePosition(); // Update the marquee position based on drag
    }

    // Function to end touch
    function endTouch() {
      isDragging = false;
      prevTranslate = currentTranslate; // Save the last position as previous
      marqueeContainer.style.transition = "transform 0.3s ease-out"; // Add smooth transition after touch ends
    }

    // Utility to get touch position
    function getPositionX(event) {
      return event.touches[0].clientX;
    }

    // Utility to set the marquee position
    function setMarqueePosition() {
      marqueeContainer.style.transform = `translateX(${currentTranslate}px)`; // Apply the translation to the container
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initSocialGallery();
  initCustomMarquee();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    initSocialGallery();
    initCustomMarquee();
  });
}
